import {
  GroupedLabTests,
  LabTest,
  LabTestType,
  useLabTestsQuery
} from '@/modules/surgicalEvent';
import { useMemo } from 'react';
import { createSelector } from 'reselect';
import {
  useQueryForCurrentPatient,
  UseQueryForCurrentPatientParam
} from '@/hooks';

type PollingConfig = UseQueryForCurrentPatientParam<any, any>['pollingInView'];

export const useCurrentLabTestsByType = (
  type: LabTestType,
  pollingInView?: PollingConfig
) => {
  const selectLabTestsByType = useMemo(
    () =>
      // Return a unique selector instance for this page so that
      // the filtered results are correctly memoized
      createSelector(
        (res: any) => res.data,
        (data: GroupedLabTests) => data?.[type]
      ),
    [type]
  );
  return useQueryForCurrentPatient<LabTest[]>({
    useQuery: useLabTestsQuery as any,
    pollingInView,
    queryConfig: {
      selectFromResult: (result) => ({
        ...result,
        data: selectLabTestsByType(result)
      })
    }
  });
};
